/* businesses */
export const GET_BUSINESSES = "GET_BUSINESSES"
export const GET_BUSINESSES_SUCCESS = "GET_BUSINESSES_SUCCESS"
export const API_ERROR = "API_ERROR"
